import classNames from 'classnames'
import React from 'react'

import Heading from '../Heading'

import { SectionProps } from './Section'

const GlobalMapSection = ({
  id,
  children,
  className,
  mainTitle,
}: Omit<SectionProps, 'mainTitle' | 'color' | 'isRelative'> & {
  mainTitle: string
}) => {
  return (
    <section
      className={classNames(
        '!flex justify-center bg-secondary-light2',
        className,
      )}
      id={id}
    >
      <div className="relative flex w-full max-w-326 flex-col justify-center bg-[url(/world-map-mobile.svg)] bg-contain bg-top bg-no-repeat pt-40 min-[1440px]:max-w-none min-[1440px]:gap-8 min-[1440px]:!bg-none md:bg-[url(/world-map.svg)] md:py-0 lg:min-h-100 lg:flex-row lg:bg-position-[-60px]">
        <div className="min-h-1 min-[1440px]:hidden min-[1440px]:min-h-0 md:h-55 lg:h-full lg:flex-1" />
        <img
          src="/world-map.svg"
          alt="World Map"
          className="hidden h-full w-full max-w-200 object-cover min-[1440px]:block"
        />
        <div className="relative flex flex-col items-center justify-center gap-4 bg-gradient-to-t from-secondary-light2 via-secondary-light2 via-45% px-5 pb-8 lg:max-w-138 lg:items-start lg:bg-gradient-to-l lg:from-secondary-light2 lg:via-secondary-light2 lg:via-75% lg:to-transparent lg:pb-0 min-xl:pr-0 min-xl:pl-0">
          <Heading
            text={mainTitle}
            isLeftAligned
            variant="title"
            className="!mb-4 sm:mb-4 md:mb-4"
          />
          <div>{children}</div>
        </div>
      </div>
    </section>
  )
}

export default GlobalMapSection
